<template>
	<div style="display: flex; justify-content: center; align-items: center; width: 100%; height: 800px">
		<div>
			<loading />
			<p style="font-weight: bold; margin-top: 30px; text-align: center;" v-if="!$store.state.authentication.checked">{{translate(locale.loading)}}<br><span>{{profile_name}}</span></p>
			<p style="font-weight: bold; text-align: center;" v-if="$store.state.authentication.checked && $store.state.authentication.expired">{{translate(locale.expired)}} <br>{{translate(locale.goHome)}}</p>
		</div>
	</div>
</template>

<script>
	export default {
		components: {
		},
		data() {
			return {
				profile_name: ""
			}
		},
		created() {

			let token = this.$route.params.token;

			this.$store.state.authentication.authToken = String(token).length > 20 ? token : this.$store.state.authentication.authToken;

			let checkToken = this.config.isJWT(this.$store.state.authentication.authToken);

			if(checkToken.valid === false) {
					this.$store.state.authentication.checked = true;
					this.$store.state.authentication.expired = true;
				setTimeout(() => {
					window.location.replace(this.config.redirect_url);
				}, 2000);

			} else {
				this.profile_name = checkToken.data.profile_name;
				this.$http.get(this.config.api + "/profile/authenticate").then(data => {

					setTimeout(() => {
						this.$store.state.authentication.checked = true;

						if(data.body.status == 'success') {
							
							this.$store.state.authentication.loggedIn = true;

							this.$store.state.authentication.profile_hash = data.body.data.profile_hash;
							this.$store.state.authentication.profile_name = data.body.data.profile_name;
							this.$store.state.authentication.profile_verified = parseInt(data.body.data.profile_verified);
							this.$store.state.authentication.user_role = data.body.data.user_role;
							
							if(String(token).length > 32) {
								this.$cookie.set('auth', this.$store.state.authentication.authToken, 2);
								this.$router.push("/my_profile");
							}	
						}
					}, 1500)
				});
			}	
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Auth.vue